import rubric from "../../data/rubric.json";

/**
 * Round to nearest integer raw score
 */
const clampRaw = (x, max) =>
  Math.max(0, Math.min(max, Math.round(x)));

/**
 * Convert expected raw correct → SAT section score
 *
 * mode: "lower" | "middle" | "upper"
 */
export const rawToScaledScore = (rawCorrect, section, mode) => {
  if (rawCorrect == null) return null;

  const max = section === "math" ? 54 : 66;
  const raw = clampRaw(rawCorrect, max);

  const table = rubric?.[section];
  if (!table || !table[raw]) return null;

  const { lower, upper } = table[raw];

  let score;
  if (mode === "lower") score = lower;
  else if (mode === "upper") score = upper;
  else {
    // 🔑 midpoint, rounded UP to nearest 10
    score = Math.ceil(((lower + upper) / 2) / 10) * 10;
  }

  return Math.round(score / 10) * 10;
};
